import { render, staticRenderFns } from "./TeacherNumber.vue?vue&type=template&id=0c203df4"
import script from "./TeacherNumber.vue?vue&type=script&lang=js"
export * from "./TeacherNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c203df4')) {
      api.createRecord('0c203df4', component.options)
    } else {
      api.reload('0c203df4', component.options)
    }
    module.hot.accept("./TeacherNumber.vue?vue&type=template&id=0c203df4", function () {
      api.rerender('0c203df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/TeacherNumber.vue"
export default component.exports